import React, { FC, useEffect, useState } from 'react';
import { parse } from 'qs';
import api, { request } from '../../api';
import Avatar from '../../components/Avatar';
import styles from './styles.module.scss';
import { useProfile } from '../../lib/auth';
import { needSubscription } from '../../components/NeedSubscriptionModal';

const Profile: FC = (): JSX.Element => {
    const [ notifications, setNotifications ] = useState<any[]>([]);
    const [ attention, setAttention ] = useState<boolean>(false);
    const [ showNotifications, setShowNotifications ] = useState<boolean>(false);
    const coach = useProfile();

    useEffect(() => {
        if (!coach) return;
        const query = parse(window.location.search.substring(1));
        if (query && query.upgrade) {
            needSubscription(coach);
        }
    }, [coach]);

    useEffect(() => {
        setAttention(notifications.filter((o) => !o.is_read).length > 0);
    }, [notifications]);

    const fetchNotifications = (): void => {
        request.get('notifications').then(({ data }) => {
            setNotifications(data.data);
        });
    }
    useEffect(() => fetchNotifications(), []);

    const readNotification = (notification: any): void => {
        request.post(`notifications/${notification.id}`).then(() => {
            fetchNotifications();
            if (notification.link === 'external') {
                window.location.href = notification.params.url;
            }
        });
        setShowNotifications(false);
    }

    return (<>
        <ul
            className="top-bar__navigation"
            style={{
                borderRight: 'solid 1px #acb4bd',
                paddingRight: 16,
                marginRight: -16,
            }}
        >
            <li data-aos="fade-down">
                <a href="/community">
                    Home
                </a>
            </li>
            <li data-aos="fade-down" data-aos-delay="50">
                <a href="/community/profiles">
                    Mijn netwerk
                </a>
            </li>
            <li data-aos="fade-down" data-aos-delay="100">
                <a href="/community/events">
                    Evenementen
                </a>
            </li>
            <li className={styles.mobile}>
                <a href={`/community/${coach?.permalink}`}>
                    Mijn profiel
                </a>
            </li>
            <li className={styles.mobile}>
                <a href="/" onClick={() => api.logout()}>
                    Uitloggen
                </a>
            </li>
        </ul>
        <div className={styles.account} data-aos="fade-down" data-aos-delay="150">
            <div className={styles.name}>
                {coach?.name}
                <div>
                    <a href={`/community/${coach?.permalink}`}>Mijn profiel</a>{' | '}
                    <a href="/" onClick={() => api.logout()}>Uitloggen</a>
                </div>
            </div>
            <a href={`/community/account`}>
                {coach && <Avatar profile={coach} />}
            </a>
            <div
                className={styles.attention}
                onClick={() => setShowNotifications((s) => !s)}
            >
                <i className="far fa-bell" />
                {attention && <span className={styles.badge} />}
            </div>

            {showNotifications && notifications.length > 0 && (
                <div className={styles.notifications}>
                    {notifications.map((notification) => (
                        <div
                            key={`noti-${notification.id}`}
                            className={styles.notification}
                            onClick={() => readNotification(notification)}
                        >
                            <div className={styles.notificationIcon}>
                                {notification.type === 'event' && <i className="far fa-calendar-alt" />}
                                {notification.type === 'mention' && <i className="far fa-at" />}
                                {notification.type === 'post' && <i className="far fa-at" />}
                                {notification.type === 'dm' && <i className="far fa-envelope" />}
                                {notification.type === 'exercise' && <i className="far fa-running" />}
                                {notification.type === 'basic' && <i className="far fa-file-pdf" />}
                                {notification.type === 'video' && <i className="far fa-video" />}
                                {notification.type === 'forumpost' && <i className="far fa-comments" />}
                                {notification.type === 'participant' && <i className="far fa-user" />}
                            </div>
                            <div className={styles.notificationMsg}>
                                {notification.message}
                            </div>
                            {!notification.is_read && <div className={styles.badge} />}
                        </div>
                    ))}
                </div>
            )}
            <label htmlFor="hamburger" className="bars">
                <input type="checkbox" id="hamburger" className="js-toggle-nav" onChange={() => document.body.classList.toggle('navigation--open')} />
                <span></span>
                <span></span>
                <span></span>
            </label>
        </div>
    </>);
}

export default Profile;
